module.exports = __webpack_public_path__ + "img/fitness-inactive.96e65e47.png";